// <head> metadata for StartupPage (https://www.dbos.dev/startup).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS for Startups',
    },
    {
      name: 'description',
      content:
        'DBOS for Startups: make apps crash-proof without writing error handling and scaling code. Startups build for free, with 3 months of free DBOS Teams.',
    },
    {
      property: 'og:title',
      content: 'DBOS for Startups',
    },
    {
      property: 'og:description',
      content:
        'DBOS for Startups: make apps crash-proof without writing error handling and scaling code. Startups build for free, with 3 months of free DBOS Teams.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/6a701bdbfaf835ece0e345ec_DBOS-StartupDiscount.png',
    },
    {
      name: 'twitter:title',
      content: 'DBOS for Startups',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS for Startups: make apps crash-proof without writing error handling and scaling code. Startups build for free, with 3 months of free DBOS Teams.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/6a701bdbfaf835ece0e345ec_DBOS-StartupDiscount.png',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/startup',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
